import React from 'react'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import Avatar from '@material-ui/core/Avatar'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import { useCardStyles } from './styles'
import { Button } from '@material-ui/core'

const CreditCard = (): JSX.Element => {
  const classes = useCardStyles()

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            <CreditCardIcon />
          </Avatar>
        }
        action={
          <span className={classes.simpleAction}>
            <p>Próximo vencimento</p>
            <h4>29/11</h4>
          </span>
        }
        title="Cartão de crédito"
        subheader="**** **** **** 8979"
      />
      <CardActions className={classes.actions}>
        <Button variant="text" color="primary" fullWidth>
          Alterar metódo de pagamento
        </Button>
      </CardActions>
    </Card>
  )
}

export default CreditCard
